import React from 'react';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

var Error = function Error(_ref) {
  var error = _ref.error,
      textSize = _ref.textSize,
      className = _ref.className;
  var message = error === null || error === void 0 ? void 0 : error.message;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: className ? className : "flex flex-row justify-center items-center space-x-2 py-12 ".concat(textSize ? textSize : 'text-2xl', " text-opacity-50 text-red-600 w-full")
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faInfoCircle
  })), error ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "ERROR")) : /*#__PURE__*/React.createElement("span", null, "Error")), /*#__PURE__*/React.createElement("div", {
    className: "mt-2 flex justify-center items-center text-xl text-opacity-70 text-red-600 w-full"
  }, message));
};

export { Error as E };
